const {BADGE_TYPES, BADGE_IDS} = require('./constants')

/**
 * Badge definitions with metadata
 */
const BADGES = {
  // Leaderboard badges
  [BADGE_IDS.BATTLE_TOP_1]: {
    id: BADGE_IDS.BATTLE_TOP_1,
    type: BADGE_TYPES.LEADERBOARD,
    name: 'Battle Top 1',
    description: 'Reached top 1 in a battle',
    icon: '⚔️',
    color: 'gold',
    level: '1st',
  },

  [BADGE_IDS.BATTLE_TOP_2]: {
    id: BADGE_IDS.BATTLE_TOP_2,
    type: BADGE_TYPES.LEADERBOARD,
    name: 'Battle Top 2',
    description: 'Reached top 2 in a battle',
    icon: '⚔️',
    color: 'silver',
    level: '2nd',
  },

  [BADGE_IDS.BATTLE_TOP_3]: {
    id: BADGE_IDS.BATTLE_TOP_3,
    type: BADGE_TYPES.LEADERBOARD,
    name: 'Battle Top 3',
    description: 'Reached top 3 in a battle',
    icon: '⚔️',
    color: 'red',
    level: '3rd',
  },

  [BADGE_IDS.TARGET_TOP_10]: {
    id: BADGE_IDS.TARGET_TOP_10,
    type: BADGE_TYPES.LEADERBOARD,
    name: 'Target Top 10',
    description: 'Reached top 10 in a target leaderboard',
    icon: '🎯',
    color: 'green-dark',
  },
  [BADGE_IDS.TARGET_TOP_5]: {
    id: BADGE_IDS.TARGET_TOP_5,
    type: BADGE_TYPES.LEADERBOARD,
    name: 'Target Top 5',
    description: 'Reached top 5 in a target leaderboard',
    icon: '🎯',
    color: 'blue-dark',
  },
  [BADGE_IDS.TARGET_TOP_3]: {
    id: BADGE_IDS.TARGET_TOP_3,
    type: BADGE_TYPES.LEADERBOARD,
    name: 'Target Top 3',
    description: 'Reached top 3 in a target leaderboard',
    icon: '🎯',
    color: 'purple',
  },
  [BADGE_IDS.TARGET_TOP_2]: {
    id: BADGE_IDS.TARGET_TOP_2,
    type: BADGE_TYPES.LEADERBOARD,
    name: 'Target Runner-up',
    description: 'Reached 2nd place in a target leaderboard',
    icon: '🥈',
    color: 'pink',
  },
  [BADGE_IDS.TARGET_TOP_1]: {
    id: BADGE_IDS.TARGET_TOP_1,
    type: BADGE_TYPES.LEADERBOARD,
    name: 'Target Champion',
    description: 'Reached 1st place in a target leaderboard',
    icon: '👑',
    color: 'gold',
  },

  // Submission badges
  [BADGE_IDS.FIRST_SUBMISSION]: {
    id: BADGE_IDS.FIRST_SUBMISSION,
    type: BADGE_TYPES.SUBMISSION,
    name: 'First Submission ❤️',
    description: 'Made first submission on a target',
    icon: '🚀',
    image: 'submission-1.png',
    color: 'blue', // blue
    particleColor: '#67AED4',
    isEnabled: true,
  },

  [BADGE_IDS.HUNDRED_SUBMISSIONS]: {
    id: BADGE_IDS.HUNDRED_SUBMISSIONS,
    type: BADGE_TYPES.SUBMISSION,
    name: '100 Submissions',
    description: 'Made 100 submissions',
    icon: '🎮',
    image: 'submission-2.png',
    color: 'orange', // pink
    level: '100',
    isEnabled: true,
  },
  [BADGE_IDS.THOUSAND_SUBMISSIONS]: {
    id: BADGE_IDS.THOUSAND_SUBMISSIONS,
    type: BADGE_TYPES.SUBMISSION,
    name: '1000 Submissions',
    description: 'Made 1000 submissions',
    icon: '🎮',
    image: 'submission-3.png',
    color: 'pink',
    level: '1K',
    isEnabled: true,
  },
  [BADGE_IDS.TEN_K_SUBMISSIONS]: {
    id: BADGE_IDS.TEN_K_SUBMISSIONS,
    type: BADGE_TYPES.SUBMISSION,
    name: '10000 Submissions',
    description: 'Made 10000 submissions',
    icon: '🎮',
    image: 'submission-4.png',
    color: 'green',
    level: '10K',
    isEnabled: true,
  },
  [BADGE_IDS.FIFTY_K_SUBMISSIONS]: {
    id: BADGE_IDS.FIFTY_K_SUBMISSIONS,
    type: BADGE_TYPES.SUBMISSION,
    name: '50000 Submissions',
    description: 'Made 50000 submissions',
    icon: '🎮',
    image: 'submission-5.png',
    color: 'green',
    level: '50K',
    isEnabled: true,
  },
  [BADGE_IDS.HUNDRED_K_SUBMISSIONS]: {
    id: BADGE_IDS.HUNDRED_K_SUBMISSIONS,
    type: BADGE_TYPES.SUBMISSION,
    name: '100000 Submissions',
    description: 'Made 100000 submissions',
    icon: '🎮',
    image: 'submission-6.png',
    color: 'blue',
    level: '100K',
    isEnabled: true,
  },

  // Target count badges
  [BADGE_IDS.TARGET_PLAYED_10]: {
    id: BADGE_IDS.TARGET_PLAYED_10,
    type: BADGE_TYPES.TARGET_PLAYED,
    name: 'Target Played 10',
    description: 'Played 10 targets',
    icon: '🎯',
    color: 'red',
    level: 10,
  },
  [BADGE_IDS.TARGET_PLAYED_50]: {
    id: BADGE_IDS.TARGET_PLAYED_50,
    type: BADGE_TYPES.TARGET_PLAYED,
    name: 'Target Played 50',
    description: 'Played 50 targets',
    icon: '🎯',
    color: 'orange',
    level: 50,
  },
  [BADGE_IDS.TARGET_PLAYED_100]: {
    id: BADGE_IDS.TARGET_PLAYED_100,
    type: BADGE_TYPES.TARGET_PLAYED,
    name: 'Target Played 100',
    description: 'Played 100 targets',
    icon: '🎯',
    color: 'yellow',
    level: 100,
  },
  [BADGE_IDS.TARGET_PLAYED_500]: {
    id: BADGE_IDS.TARGET_PLAYED_500,
    type: BADGE_TYPES.TARGET_PLAYED,
    name: 'Target Played 500',
    description: 'Played 500 targets',
    icon: '🎯',
    color: 'green',
    level: 500,
  },
  [BADGE_IDS.TARGET_PLAYED_1000]: {
    id: BADGE_IDS.TARGET_PLAYED_1000,
    type: BADGE_TYPES.TARGET_PLAYED,
    name: 'Target Played 1000',
    description: 'Played 1000 targets',
    icon: '🎯',
    color: 'blue',
    level: '1K',
  },

  // Streak badges
  [BADGE_IDS.STREAK_7]: {
    id: BADGE_IDS.STREAK_7,
    type: BADGE_TYPES.STREAK,
    name: 'Streak 7',
    description: 'Achieved a 7-day streak',
    icon: '👟',
    image: 'streak-1.png',
    color: 'yellow',
    level: 7,
    isEnabled: true,
  },
  [BADGE_IDS.STREAK_30]: {
    id: BADGE_IDS.STREAK_30,
    type: BADGE_TYPES.STREAK,
    name: 'Streak 30',
    description: 'Achieved a 30-day streak',
    icon: '👟',
    image: 'streak-2.png',
    color: 'orange',
    level: 30,
    isEnabled: true,
  },
  [BADGE_IDS.STREAK_100]: {
    id: BADGE_IDS.STREAK_100,
    type: BADGE_TYPES.STREAK,
    name: 'Streak 100',
    description: 'Achieved a 100-day streak',
    icon: '👟',
    image: 'streak-3.png',
    color: 'green',
    particleColor: 'limegreen',
    level: 100,
    isEnabled: true,
  },
  [BADGE_IDS.STREAK_365]: {
    id: BADGE_IDS.STREAK_365,
    type: BADGE_TYPES.STREAK,
    name: 'Streak 365',
    description: 'Achieved a 365-day streak',
    icon: '👟',
    image: 'streak-4.png',
    color: 'blue',
    level: 365,
    isEnabled: true,
  },
  [BADGE_IDS.STREAK_500]: {
    id: BADGE_IDS.STREAK_500,
    type: BADGE_TYPES.STREAK,
    name: 'Streak 500',
    description: 'Achieved a 500-day streak',
    icon: '👟',
    image: 'streak-5.png',
    color: 'purple',
    level: 500,
    isEnabled: true,
  },
  [BADGE_IDS.STREAK_2Y]: {
    id: BADGE_IDS.STREAK_2Y,
    type: BADGE_TYPES.STREAK,
    name: 'Streak 2 Years',
    description: 'Achieved a 2-year streak',
    icon: '👟',
    image: 'streak-6.png',
    color: 'red',
    level: '2Y',
    isEnabled: true,
  },
}

/**
 * Get badge details by ID
 * @param {string} badgeId - The badge ID
 * @returns {object} Badge details
 */
function getBadgeDetails(badgeId) {
  return BADGES[badgeId]
}

/**
 * Get all badges
 * @returns {object} All badges
 */
function getAllBadges() {
  return BADGES
}

/**
 * Get badges by type
 * @param {string} type - Badge type
 * @returns {Array} Badges of the specified type
 */
function getBadgesByType(type) {
  return Object.values(BADGES).filter((badge) => badge.type === type)
}

module.exports = {
  BADGES,
  getBadgeDetails,
  getAllBadges,
  getBadgesByType,
}
